@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;
  min-width: 0; // Fix flexbox overflow
  flex-grow: 1; // IE11 width fix
  flex-shrink: 1;
  box-sizing: border-box;

  @include screen-ie-only {
    width: 100% !important; // IE11 width fix
  }

  .fluid-content {
    height: 100%;
    display: block;
    padding-top: calc(var(--G-content-padding-top) / 2);
    padding-bottom: calc(var(--G-content-padding-bottom) / 2);
    padding-left: calc(var(--G-content-padding-left) / 2);
    padding-right: calc(var(--G-content-padding-right) / 2);

    @include screen-lg {
      padding-top: var(--G-content-padding-top);
      padding-bottom: var(--G-content-padding-bottom);
      padding-left: var(--G-content-padding-left);
      padding-right: var(--G-content-padding-right);
    }

    &.variant-atmospheric {
      background-color: $liberty-gray-4;
    }
  }
}
